import { render, staticRenderFns } from "./AppStoreChannels.vue?vue&type=template&id=51435b35&scoped=true"
import script from "./AppStoreChannels.vue?vue&type=script&lang=js"
export * from "./AppStoreChannels.vue?vue&type=script&lang=js"
import style0 from "./AppStoreChannels.vue?vue&type=style&index=0&id=51435b35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51435b35",
  null
  
)

export default component.exports